export default {
  root: {
    fontSize: '2.5rem',
    color: 'grey',
  },
};
